import {
  failToast,
  getURLInfo,
  swapToast,
  getErrorMessage,
  parsedArgs,
  parsedTransactionSuccessValue,
  LimitOrderFailPopUp,
  LimitOrderPopUp,
  checkCrossSwapTransactions,
} from '../../components/layout/transactionTipPopUp';
import { useHistory } from 'react-router';
import { useWalletSelector } from '../../context/WalletSelectorContext';
import { usePersistSwapStore } from '../../stores/swapStore';
import { ONLY_ZEROS } from './swapStateShared';
import { V3_POOL_SPLITTER } from '../../services/swapV3';
import { ftGetTokenMetadata } from '../../services/ft-contract';
import {
  scientificNotationToString,
  toReadableNumber,
  toPrecision,
} from '../../utils/numbers';
import Big from 'big.js';
import { toRealSymbol } from '../../utils/token';
import { REF_FI_SWAP_SIGNAL } from '../../services/swapTypes';
import { useContext, useEffect } from 'react';
import {
  getCurrentWallet,
  WalletContext,
} from '../../utils/wallets-integration';
import { checkTransaction } from '../../services/swapExecution';
import { token_usdc_id } from '../../utils/swapConfig';
import { safeJSONParse } from 'src/utils/safeJSONParse';

export const useSwapPopUp = () => {
  const { txHash, pathname, errorType } = getURLInfo();
  const history = useHistory();
  const { accountId } = useWalletSelector();
  const {
    near_usdt_swapTodos,
    near_usdt_swapTodos_transaction,
    set_near_usdt_swapTodos_transaction,
  } = usePersistSwapStore();

  const parseLimitOrderPopUp = async (transactionResult: any) => {
    const byNeth =
      transactionResult?.transaction?.actions?.[0]?.FunctionCall
        ?.method_name === 'execute';
    const byEvm =
      transactionResult?.transaction?.actions?.[0]?.FunctionCall
        ?.method_name === 'rlp_execute';
    const isPackage = byNeth || byEvm;
    const ft_resolved_id =
      transactionResult?.receipts?.findIndex((receipt: any) =>
        receipt?.receipt?.Action?.actions?.some(
          (action: any) =>
            action?.FunctionCall?.method_name === 'ft_resolve_transfer'
        )
      ) + (isPackage ? 1 : 0);

    const ft_on_transfer_id =
      transactionResult?.receipts?.findIndex((receipt: any) =>
        receipt?.receipt?.Action?.actions?.some(
          (action: any) =>
            action?.FunctionCall?.method_name === 'ft_on_transfer'
        )
      ) + (isPackage ? 1 : 0);

    const ft_transfer_call_args = parsedArgs(
      isPackage
        ? transactionResult?.receipts?.[0]?.receipt?.Action?.actions?.[0]
            ?.FunctionCall?.args
        : transactionResult?.transaction?.actions?.[0]?.FunctionCall?.args || ''
    );

    const parsedInputArgs = JSON.parse(ft_transfer_call_args || '');

    const LimitOrderWithSwap = JSON.parse(
      parsedInputArgs?.msg || '{}'
    )?.LimitOrderWithSwap;

    if (!LimitOrderWithSwap) {
      return false;
    }

    const ft_resolved_tx_outcome =
      transactionResult?.receipts_outcome?.[ft_resolved_id]?.outcome;

    const parsedValue = JSON.parse(
      parsedTransactionSuccessValue(ft_resolved_tx_outcome) || ''
    );

    const isFailed = ONLY_ZEROS.test(parsedValue || 0);

    if (isFailed) {
      LimitOrderFailPopUp(txHash);
      return true;
    }

    const ft_on_transfer_logs =
      transactionResult?.receipts_outcome?.[ft_on_transfer_id]?.outcome?.logs;

    const ft_on_transfer_log =
      ft_on_transfer_logs?.[ft_on_transfer_logs?.length - 1];

    const jsonStartIndex = ft_on_transfer_log?.indexOf('{');

    const parsed_ft_on_transfer_log = JSON.parse(
      ft_on_transfer_log.slice(jsonStartIndex) || ''
    );

    const order_id = parsed_ft_on_transfer_log?.data?.[0]?.order_id;

    const original_amount =
      parsed_ft_on_transfer_log?.data?.[0]?.original_amount;

    const original_deposit_amount =
      parsed_ft_on_transfer_log?.data?.[0]?.original_deposit_amount;

    const { point, pool_id, buy_token } = LimitOrderWithSwap;

    const ids = pool_id.split(V3_POOL_SPLITTER).splice(0, 2);

    const sell_token_id = ids.find((tokenId: string) => tokenId !== buy_token);

    const sellToken = await ftGetTokenMetadata(sell_token_id);

    const ft_on_transfer_log_swap = ft_on_transfer_logs?.[0];

    const idx_swap = ft_on_transfer_log?.indexOf('{');

    const parsed_ft_on_transfer_log_swap = JSON.parse(
      ft_on_transfer_log_swap.slice(idx_swap) || ''
    );

    if (!!order_id) {
      // const buyAmount = parsed_ft_on_transfer_log_swap?.['data']?.[0]?.['amount_out'];

      const limitOrderAmount =
        Number(toReadableNumber(sellToken.decimals, original_amount || '0')) <
        0.01
          ? '< 0.01'
          : toPrecision(
              toReadableNumber(sellToken.decimals, original_amount || '0'),
              2
            );

      const swapAmount = toReadableNumber(
        sellToken.decimals,
        scientificNotationToString(
          new Big(original_deposit_amount || '0')
            .minus(original_amount || '0')
            .toString()
        )
      );

      let swapAmountOut =
        Number(swapAmount) == 0
          ? '0'
          : parsed_ft_on_transfer_log_swap?.data?.[0]?.amount_out;

      const buyToken = await ftGetTokenMetadata(buy_token);

      swapAmountOut = toReadableNumber(buyToken.decimals, swapAmountOut);

      LimitOrderPopUp({
        tokenSymbol: toRealSymbol(sellToken.symbol),
        swapAmount:
          Number(swapAmount) > 0 && Number(swapAmount) < 0.01
            ? '< 0.01'
            : toPrecision(swapAmount, 2, false, false),
        limitOrderAmount,
        tokenOutSymbol: toRealSymbol(buyToken.symbol),

        txHash,
        swapAmountOut:
          Number(swapAmountOut) > 0 && Number(swapAmountOut) < 0.01
            ? '< 0.01'
            : toPrecision(swapAmountOut, 2, false, false),
      });
    } else {
      const swapAmount = toReadableNumber(sellToken.decimals, parsedValue);

      let swapAmountOut =
        Number(swapAmount) == 0
          ? '0'
          : parsed_ft_on_transfer_log_swap?.data?.[0]?.amount_out;

      const buyToken = await ftGetTokenMetadata(buy_token);

      swapAmountOut = toReadableNumber(buyToken.decimals, swapAmountOut);

      // all swap
      LimitOrderPopUp({
        tokenSymbol: toRealSymbol(sellToken.symbol),
        swapAmount:
          Number(swapAmount) < 0.01
            ? '< 0.01'
            : toPrecision(swapAmount, 2, false, false),
        limitOrderAmount: null,
        txHash,
        tokenOutSymbol: toRealSymbol(buyToken.symbol),
        swapAmountOut:
          Number(swapAmountOut) > 0 && Number(swapAmountOut) < 0.01
            ? '< 0.01'
            : toPrecision(swapAmountOut, 2, false, false),
      });
    }

    // success pop up

    return true;

    // find ft_resolve_on tx
  };

  const swapSig = localStorage.getItem(REF_FI_SWAP_SIGNAL);
  useEffect(() => {
    if (swapSig === 'tri') return;
    if (txHash && getCurrentWallet().wallet.isSignedIn()) {
      if (
        near_usdt_swapTodos_transaction &&
        near_usdt_swapTodos_transaction?.process !== '0'
      ) {
        set_near_usdt_swapTodos_transaction(null);
      }
      checkTransaction(txHash)
        .then(async (transactionResult: any) => {
          let isLimitOrder;
          try {
            isLimitOrder = await parseLimitOrderPopUp(transactionResult);
          } catch (error) {}
          const transactionErrorType = getErrorMessage(transactionResult);
          const byNeth =
            transactionResult?.transaction?.actions?.[0]?.FunctionCall
              ?.method_name === 'execute';
          const byEvm =
            transactionResult?.transaction?.actions?.[0]?.FunctionCall
              ?.method_name === 'rlp_execute';
          const isPackage = byNeth || byEvm;
          const transaction = transactionResult.transaction;
          const isSwapReceipt = !!transactionResult?.receipts?.find(
            (receipt) => {
              return (
                receipt?.receipt?.Action?.actions?.[0]?.FunctionCall
                  ?.method_name === 'ft_transfer_call' ||
                receipt?.receipt?.Action?.actions?.[0]?.FunctionCall
                  ?.method_name === 'near_withdraw' ||
                receipt?.receipt?.Action?.actions?.[0]?.FunctionCall
                  ?.method_name === 'near_deposit' ||
                receipt?.receipt?.Action?.actions?.[0]?.FunctionCall
                  ?.method_name === 'swap'
              );
            }
          );
          return {
            isSwap:
              (transaction?.actions[1]?.FunctionCall?.method_name ===
                'ft_transfer_call' ||
                transaction?.actions[0]?.FunctionCall?.method_name ===
                  'ft_transfer_call' ||
                transaction?.actions[0]?.FunctionCall?.method_name === 'swap' ||
                transaction?.actions[0]?.FunctionCall?.method_name ===
                  'near_deposit' ||
                transaction?.actions[0]?.FunctionCall?.method_name ===
                  'near_withdraw' ||
                isSwapReceipt) &&
              !isLimitOrder,
            transactionErrorType,
            res: transactionResult,
          };
        })
        .then(({ isSwap, transactionErrorType, res: transactionResult }) => {
          if (isSwap) {
            if (!transactionErrorType && !errorType) {
              if (near_usdt_swapTodos_transaction?.process == '0') {
                handle_near_usdt_swap(transactionResult);
              } else {
                if (near_usdt_swapTodos_transaction) {
                  set_near_usdt_swapTodos_transaction(null);
                }
                swapToast(txHash);
              }
            } else if (transactionErrorType) {
              failToast(txHash, transactionErrorType);
            }
          }
          history.replace(pathname);
        });
    }
  }, [txHash]);
  function handle_near_usdt_swap(transactionResult: any) {
    const targetReceipt = transactionResult.receipts.find((receipt) => {
      return (
        receipt.receiver_id == token_usdc_id &&
        receipt.receipt?.Action?.actions?.[0]?.FunctionCall?.method_name ==
          'ft_transfer'
      );
    });
    const args = parsedArgs(
      targetReceipt.receipt?.Action?.actions?.[0]?.FunctionCall?.args
    );
    const argsObj: {
      receiver_id: string;
      amount: string;
    } = safeJSONParse(args);
    if (argsObj?.amount && argsObj?.receiver_id == accountId) {
      set_near_usdt_swapTodos_transaction({
        ...near_usdt_swapTodos_transaction,
        process: '1',
        dcl_quote_amout_real: argsObj?.amount,
      });
    } else {
      set_near_usdt_swapTodos_transaction(null);
    }
  }
};

export const useCrossSwapPopUp = () => {
  const { pathname, txHashes } = getURLInfo();
  const history = useHistory();

  const { globalState } = useContext(WalletContext);

  const isSignedIn = globalState.isSignedIn;

  const swapSig = localStorage.getItem(REF_FI_SWAP_SIGNAL);

  useEffect(() => {
    if (txHashes && txHashes.length > 0 && isSignedIn && swapSig === 'tri') {
      checkCrossSwapTransactions(txHashes).then(
        async (crossSwapResult: {
          status: boolean;
          hash: string;
          errorType?: string;
        }) => {
          const { status, hash, errorType } = crossSwapResult;

          if (errorType || !status) {
            failToast(hash, errorType);
          } else {
            swapToast(hash);
          }
        }
      );
      history.replace(pathname);
    }
  }, [txHashes]);
};
